import { NgClass } from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-item-delete',
  imports: [
    FormsModule,
    MatDialogActions,
    MatDialogContent,
    ReactiveFormsModule,
    NgClass
],
  templateUrl: './item-delete.component.html',
  styleUrl: './item-delete.component.css'
})
export class ItemDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ItemDeleteComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    console.log(this.data)
  }


  close(): void {
    this.dialogRef.close(false)
  }

  delete(): void {
    this.dialogRef.close(true)
  }
}
